import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import DatePicker from 'react-multi-date-picker';
import dayjs from 'dayjs';
import { useStoreon } from 'storeon/react';

import { GxButton, GxIcon } from '@garpix/garpix-web-components-react';

import ModalFlyListBlock from '@/apps/Applications/components/ModalFlyListBlock';
import { Events, State } from '@/interfaces';
import { PencilIcon } from '@/assets';
import useModalFlag from '@/hooks/useModalFlag';
import CalendarIcon from '../../../../assets/icons/CalendarIcon.svg';
import { weekDays, months } from '../../../../const/calendar';

import styles from './styles/index.module.scss';
import './styles/styles.css';

export const SchedulePanel = () => {
  const {dispatch, dateFlyingList} = useStoreon<State, Events>('dateFlyingList');
  const [date, setDate] = useState<Date>(dateFlyingList);
  const { flag, setModalFlag } = useModalFlag();

  const closeModal = () => {
    setModalFlag();
  };

  const handleClickCreateBlock= () => {
    setModalFlag();
  };

  function CustomRangeInput({ openCalendar, value }: any) {
    const valueNew = `${dayjs(value).format('DD.MM.YYYY')} ${dayjs(date).format(
      'dddd'
    )}`;
    const handleClickBtnControl = (type: string) => {
      let newDate: Date;
      if (type === 'back') {
          newDate = dayjs(date).subtract(1, 'day').toDate();
      } else {
        newDate = dayjs(date).add(1, 'day').toDate();
      }
      setDate(newDate);
      dispatch('setFlyingListDate', newDate);
    };


    useEffect(() => {
      dispatch('flyingList/get', { date: dayjs(date).format('YYYY-MM-DD') })

      return () => {
        dispatch('flyingList/clear');
      }
    }, [date]);
    return (
      <div className={styles['calendar']}>
        <label htmlFor='date'>
          <input
            id='date'
            value={valueNew}
            readOnly
            className={styles['calendar--input']}
            onFocus={openCalendar}
          />
        </label>
        <div className={styles['btn-control']}>
          <button
            type='button'
            onClick={() => handleClickBtnControl('back')}
            className={styles['btn-control--back']}
          />
          <button
            type='button'
            onClick={() => handleClickBtnControl('forward')}
            className={styles['btn-control--forward']}
          />
        </div>
        <div
          className={cn(styles['button'], styles['button--calendar'])}
          role='button'
          tabIndex={0}
          onClick={openCalendar}
        >
          <GxIcon
            className={styles['button--icon_calendar']}
            src={CalendarIcon}
          />
        </div>
      </div>
    );
  }

  const changeCalendar = (date: any) => {
    setDate(date);
    dispatch('setFlyingListDate', dayjs(date).toDate());
  };

  return (
    <>
      <div className={styles['panel']}>
        <div className={styles['panel__left-group']}>
          <DatePicker
            weekDays={weekDays}
            months={months}
            value={date}
            weekStartDayIndex={1}
            onChange={(e) => changeCalendar(e)}
            render={<CustomRangeInput />}
          />
        </div>
        <div className={styles['panel__right-group']}>
          <GxButton
            className={cn(styles['button'], styles['button--create_record'])}
            onClick={handleClickCreateBlock}
          >
            <GxIcon
              className={styles['button--icon_create']}
              src={PencilIcon}
            />
            <span>Создать блок</span>
          </GxButton>
        </div>
      </div>
      {flag && <ModalFlyListBlock flag={flag} onRequestClose={closeModal} date={date}/>}
    </>
  );
};

